<template>
  <div :class="divClass">
    <div class="d-inline-block font-weight-bold" :style="style">
      {{ label }}
    </div>
    <div class="d-inline px-1 font-weight-med text-no-wrap" :style="valStyle">
      {{ val | truncate(truncate) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "KeyValue",
  props: {
    label: [Number, String],
    val: [Number, String],
    valStyle: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 90,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    truncate: { type: Number, default: 1000 },
  },
  computed: {
    style: function () {
      return this.inline ? "" : `width: ${this.width}px;`;
    },
    divClass: function () {
      return this.inline ? "d-inline-block mr-10" : "block";
    },
  },
};
</script>

<style scoped></style>
